import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TSDRevokePresentationNotificationData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useRevokePresentationNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: TSDRevokePresentationNotificationData) => {
      const result = await apiClient.tsd.revokePresentationNotification.mutation({ body: data });
      if (result.status !== 200) {
        throw result.body;
      }
      return result.body.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success('Temporary storage declaration revoked successfully!');
    },
    onError: (error) => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      showErrorToast(error, `Error revoking the temporary storage declaration!`);
    },
  });
};
